import dayjs from "dayjs";
import { enqueueSnackbar } from "notistack";
import React, { useState } from "react";
import ConfirmComp from "src/components/shared/ConfirmComp";
import DeleteIcon from "src/components/shared/icon/DeleteIcon";
import UpdateIcon from "src/components/shared/icon/UpdateIcon";
import useAppGlobal from "src/context/useAppGlobal";
import useBatchRemove from "src/hooks/batch/useBatchRemove";
import { PERMISSIONS, useRoleCheck } from "src/hooks/permission/permission";
import { v4 as uuid } from "uuid";

export default function useBatchAction({ setBatchDetail, batchDetail }) {
  const permissionCheck = useRoleCheck();
  const { handleOpenDialog, closeDialog } = useAppGlobal();
  const [batchId, setBatchId] = useState();
  const { trigger: removeBatch } = useBatchRemove(batchId);

  const handleBatchUpdate = (item) => {
    setBatchDetail({
      warehouse: item?.warehouse,
      batchId: item?._id,
      productId: item?.productModel?.product,
      productModel: item?.productModel?._id,
      code: item?.code,
      mfg: dayjs(item?.mfg),
      exp: dayjs(item?.exp),
      qty: item?.qty,
    });
  };

  const handleBatchRemove = async (item) => {
    const res = await removeBatch();
    if (res?.success) {
      closeDialog();
      return enqueueSnackbar("Thành công", { variant: "success" });
    } else {
      return enqueueSnackbar(res?.error?.message, { variant: "error" });
    }
  };

  const action = [
    {
      id: uuid(),
      icon: <UpdateIcon />,
      onClick: (item) => handleBatchUpdate(item),
      type: "icon",
      require: ["update", "full"],
      disabled: !permissionCheck([PERMISSIONS.DELETE_BATCH_ALL, PERMISSIONS.DELETE_BATCH_OWN]),
    },
    {
      id: uuid(),
      icon: <DeleteIcon />,
      onClick: (item) => {
        setBatchId(item?._id);
        handleOpenDialog({
          content: (
            <ConfirmComp
              name={item?.name}
              onConfirm={() => handleBatchRemove(item?._id)}
            />
          ),
          size: "md",
        });
      },
      type: "icon",
      require: ["delete", "full"],
      disabled: !permissionCheck([PERMISSIONS.DELETE_BATCH_ALL, PERMISSIONS.DELETE_BATCH_OWN]),
    },
  ];
  return action;
}
